export const RCP_HELPER_NAME = 'salesAssistURL';
export const RCP_HELPER_TYPE = 'URL';
